<template>
	<section id="aboutUs">
        <div id="breadcrumb">
            <div class="container">
                <ul>
                    <li><router-link to="/"  tag="a">Home</router-link></li>
                    <li class="last">About Us</li>
                </ul>
            </div>
        </div>
		<div id="account-banner">
			<img src="../../../assets/img/Hero-banner.png" alt="">
		</div>
		<div id="about-content">
            <div class="container">
                <div class="row mb-5">
                    <div class="col-12">
                        <h1>About Us</h1>
                        <p>
                            Lorem ipsum dolor sit amet, solum dictas vim cu, ne his hendrerit deterruisset, id sed doctus fuisset intellegam. Per case melius assentior ea. Et scaevola insolens eum. Ad vix verear eruditi ncillae, fabulas assentior his at, eum no dico euripidis prehendunt. Cibo delectus eu ius, usu veri putent at.

His tamquam evertitur appellantur an, eam omnis blandit officiis id, eu nostro tacimates pri. Te vim denique fabellas deseruisse, ad est mandamus neglegentur, vim adhuc consequat an. At putent commodo patrioque pro, nihil reprimique et pro. Et sea graece consulatu conclusionemque. Doctus iudicabit ex eam.

Vel quando oratio maiorum eu, diam admodum tincidunt ad pri, vis an reque postea. Has nisl temporibus cu. Est cu aperiam splendide, sit et mazim sonet mollis. Wisi homero inermis no pri, ancillae sensibus no nam. Has quem stet eu, elit persius id mel. Ea nam magna quidam, ex ignota inimicus expetendis nam, et nec eius postea.

Meliore vivendum imperdiet no eos, quo te admodum voluptatum disputationi, id qui docendi expetenda. Ne velit efficiendi has, ut vidisse integre antiopam sea. An luptatum tractatos has. Ut est decore sanctus. Legere tibique lucilius est ut, nisl posse per at.

Quo ut democritum assueverit contentiones, enim congue delectus et per. Ei cum euripidis sadipscing. Et simul voluptua appetere mea, in sit dolores posidonium. Ut suas denique mel, ei cum etiam animal.

Eius laudem consulatu ex mei. Nam id porro saepe. Eam id habemus recusabo posidonium. Cu soluta fierent sed, at mea perfecto mediocrem voluptaria, tation aliquid oporteat at mei.

Mel dolorum fuisset id, no usu eirmod dignissim. Mei te brute ullamcorper, facilis eloquentiam liberavisse mea ex. Eu omittam ponderum sea. Debet concludaturque conclusionemque per id, ne quo utinam probatus insolens. Altera ancillae temporibus ad mei, cum perfecto maluisset an. Quas modus utroque et mei, te his amet soleat efficiantur, aliquid corpora deleniti cu has.

No his possim blandit constituam, et meliore lobortis pro. Qui te impetus volumus adipiscing. Est in dolores voluptaria, est et esse recusabo. Id vis quod eleifend, usu at timeam fabulas fastidii, ornatus docendi democritum ea usu. Ius inermis adversarium ne.

At deleniti posidonium his. In homero lobortis duo, at nibh recusabo salutatus eam. At vim repudiare evertitur abhorreant, est ei nobis choro assueverit. Sea no saepe expetendis adipiscing. Ad iudico perpetua nec, ei duo nonumy interesset, ridens laboramus sed ex.

Vis ad movet dicunt, ea modus tincidunt sea. Populo impetus offendit eu sit, his at scripserit definitionem, mei amet tale alterum ut. Veniam dissentiet eum et, tota legere tacimates et his, nec ut sonet sensibus maluisset. Graece docendi maluisset vix ad, tantas consul posidonium ei vel.
                        </p>
                    </div>
                </div>

                <div class="row mb-4">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-lg-6 mb-4 mb-lg-0">
                                <div class="bg-grey">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                                </div>
                            </div>

                             <div class="col-lg-6 mb-4 mb-lg-0">
                                <div class="bg-dark-grey">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
		</div>

		<div id="about-secondary-content">
			<div class="container">
                <div class="row mb-5">
                    <div class="col-12">
                        <h2>The Steele Group</h2>
                    </div>
                </div>
				<div class="row mb-4">
                    <div class="col-lg-4 mb-4 mb-lg-0">
                        <div class="comp-listing">
                            <img src="../../../assets/img/JC_Steele_Img.png" alt="">
                            <div class="cl-content">
                                <div class="cl-heading">Steele USA</div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud </p>
                                <a href="#" class="btn btn-primary">Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4 mb-lg-0">
                        <div class="comp-listing">
                            <img src="../../../assets/img/JC_Steele_Img.png" alt="">
                            <div class="cl-content">
                                <div class="cl-heading">Steele USA</div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud </p>
                                <a href="#" class="btn btn-primary">Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="comp-listing">
                            <img src="../../../assets/img/JC_Steele_Img.png" alt="">
                            <div class="cl-content">
                                <div class="cl-heading">Steele USA</div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud </p>
                                <a href="#" class="btn btn-primary">Learn More</a>
                            </div>
                        </div>
                    </div>
				</div>
                <div class="row mb-4">
                    <div class="col-lg-4 mb-4 mb-lg-0">
                        <div class="comp-listing">
                            <img src="../../../assets/img/JC_Steele_Img.png" alt="">
                            <div class="cl-content">
                                <div class="cl-heading">Steele USA</div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud </p>
                                <a href="#" class="btn btn-primary">Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4 mb-lg-0">
                        <div class="comp-listing">
                            <img src="../../../assets/img/JC_Steele_Img.png" alt="">
                            <div class="cl-content">
                                <div class="cl-heading">Steele USA</div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud </p>
                                <a href="#" class="btn btn-primary">Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="comp-listing">
                            <img src="../../../assets/img/JC_Steele_Img.png" alt="">
                            <div class="cl-content">
                                <div class="cl-heading">Steele USA</div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud </p>
                                <a href="#" class="btn btn-primary">Learn More</a>
                            </div>
                        </div>
                    </div>
				</div>
			</div>
		</div>

        <div id="about-content-image">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="lr-container row">
                            <div class="col-lg-6 mb-4 mb-lg-0 pr-auto pr-lg-0">
                                <div class="bg-dark-grey">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                                </div>
                            </div>
                            <div class="col-lg-6 pl-auto pl-lg-0">
                                <img src="../../../assets/img/steel-bits.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="about-image-bg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                    </div>
                </div>
            </div>
        </div>

            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="red-cta row align-items-center">
                            <div class="col-lg-3 mb-4 mb-lg-0">
                                <div class="cta-heading">
                                    A CTA Example that Spans two lines
                                </div>
                            </div>
                            <div class="col-lg-6 mb-4 mb-lg-0">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis </p>
                            </div>
                            <div class="col-lg-3">
                                <a href="/contact/index" class="btn btn-dark">Contact Us Today</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
	</section>
</template>

<script>
export default {
  name: "AboutUs",
  data() {
    return {
        
    };
  }
};
</script>
